import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { _ENDPOINT } from '../../endpoints/endpoint';
import { NetworkService } from '../../services/network.service';
import { SecurityService } from '../../services/security.service';
import { Utility } from '../../utility/utility';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit, OnDestroy {

  loginForm: FormGroup;
  destroy$ = new Subject<boolean>();

  regexPassword: string = "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})";


  constructor(private formBuilder: FormBuilder, private route: Router, private networkService: NetworkService,
    private spinner: NgxSpinnerService, private toastr: ToastrManager, private securityService: SecurityService) { }

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      newpassword: ['', [Validators.required]],
      repeatpassword: ['', [Validators.required]]
    });
  }

  confirmChange(){
    if(this.validaPassword()){
      this.login();
    }
  }

  validaPassword(){
    let userLoginDto = {
      newpassword: this.loginForm?.controls['newpassword'].value,
      repeatpassword: this.loginForm?.controls['repeatpassword'].value,
    }

    let regexPass = new RegExp(this.regexPassword);
    if (!regexPass.test(userLoginDto.newpassword)) {
      this.toastr.errorToastr('The password must contain at least 8 characters, one uppercase character, one lowercase character, one number and one special character!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
      return false;
    }

    if(userLoginDto.newpassword!=userLoginDto.repeatpassword){
      this.toastr.errorToastr('New Password and Repeat Password do not match!', 'Error', { 'animate': 'slideFromRight', 'timeout': '1000' });

      return false;
    }

    return true;
  }

  login(): void {
    this.spinner.show('sp1');
    let userLoginDto = {
      newPassword: this.loginForm?.controls['newpassword'].value,
      username: this.securityService.getUsername(),
      oldPassword: this.loginForm?.controls['oldpassword']?.value,
    }
    let data = Utility.createBodyForPostRequest(userLoginDto);

    let urlLogin: string = environment.basePath + _ENDPOINT.resetPassword;
    this.networkService.post(urlLogin, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {
        if (this.networkService.checkEnvironmentIsDev()) {

          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.spinner.hide('sp1');
            let loginResponseDto: any = JSON.parse(response.body);
            if (loginResponseDto && loginResponseDto.esito && loginResponseDto.esito == "OK") {
              this.spinner.hide('sp1');
              this.toastr.successToastr(loginResponseDto.msg, 'Reset Password result', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.securityService.logout();
            } else if (loginResponseDto && loginResponseDto.esito && loginResponseDto.esito == "KO") {
              this.spinner.hide('sp1');
              this.toastr.errorToastr(loginResponseDto.msg, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            } else {
              this.spinner.hide('sp1');
              this.toastr.errorToastr('Error during change password', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            }
          } else if (response && response.statusCode == '500' && response.body && response.body.length > 0) {
            this.spinner.hide('sp1');
            this.toastr.errorToastr(response.body, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        } else {
          console.log(typeof response);
          if (response && response.esito) {
            this.spinner.hide('sp1');
            let loginResponseDto: any = response;
            if (loginResponseDto && loginResponseDto.esito && loginResponseDto.esito == "OK") {
              this.spinner.hide('sp1');
              this.toastr.successToastr(loginResponseDto.msg, 'Change Password result', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.securityService.logout();
            } else if (loginResponseDto && loginResponseDto.esito && loginResponseDto.esito == "KO") {
              this.spinner.hide('sp1');
              this.toastr.errorToastr(loginResponseDto.msg, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            } else {
              this.spinner.hide('sp1');
              this.toastr.errorToastr('Error during change password', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            }
          } else if (response && response.length && response.length > 0) {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          } else {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr('Error during change password', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        }
      },
        err => {
          this.spinner.hide('sp1');
          console.error(err);
          this.toastr.errorToastr('Error during change password', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
        });;
  }



  loginDisabled() {
    return this.loginForm?.invalid;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}

